import { SolarPanel } from './SolarPanel'

export class MPPTracker {
	IdcMaxSym?: number;

	constructor(IdcMaxSym: number) {
		this.IdcMaxSym = IdcMaxSym;
	}

	static getMaxStringCount(panel: SolarPanel, IdcMaxSym?: number): number {
		let strCount: number;
		strCount = IdcMaxSym! / panel.Ipm! | 0;
		return strCount;
	}
}
